require.register("work/controllers/editCtrl", function(exports, require, module){
  $0
  
});

